import { Component, Inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { QRCodeController } from '@shared/src/controllers/qrcode/qrcode.controller';
import { RouteCMRAgents, RouteCMRAgentsEnum } from '@shared/src/controllers/route/cmr/RouteCMRAgents';
import { FileUpDownLoadDto } from '@shared/src/dtos/base/FileUpDownLoadDto';
import { RouteCMRQrDto } from '@shared/src/dtos/route/cmr/qr/RouteCMRQrDto';
import { HString } from '@shared/src/public-api';

@Component({
  selector: 'shared-cmr-qr-component',
  templateUrl: './shared.cmr.qr.component.html',
  styleUrls: ['./shared.cmr.qr.component.scss'],
})
export class SharedCMRQRComponent {

  constructor(private qRCodeController: QRCodeController,
    @Inject('HomeController') protected homeController: HomeController,
    protected router: Router) {
    if (homeController.useIonic) this.useIonic = homeController.useIonic();
  };

  public useIonic: boolean = false;

  @Input()
  public helpResource: string; 
  
  private _agent: RouteCMRAgents;
  @Input()
  public set agent(value: RouteCMRAgents) {
      if (this._agent === value)
          return;
      this._agent = value;
  }
  public get agent(): RouteCMRAgents {
      return this._agent;
  }

  private _uuidQR: string;
  @Input()
  public set uuidQR(value: string) {
      if (this._uuidQR === value)
          return;
      this._uuidQR = value;
      this.loadQR();
  }
  public get uuidQR(): string {
      return this._uuidQR;
  }

  ngOnInit() {

  }

  onClickQR(){
    if (!HString.isNullOrNullString(this.uuidQR)){
        //Si la visualització es per agent, el qr ens portara als documents directament, sinó, als qrs dels documents
        if(RouteCMRAgentsEnum.isValid(this.agent))
            this.homeController.routeToExternalCMRAgentUUIDQR(this.agent, this.uuidQR);
        else   
            this.homeController.routeToExternalCMRsUUIDQR(this.uuidQR);
    }
  }

  public filedto: FileUpDownLoadDto;
  public formatDocumentQRCode: string;
  loadQR() {
    if (!HString.isNullOrNullString(this.uuidQR)) {
        if(RouteCMRAgentsEnum.isValid(this.agent)){
            this.qRCodeController.getQRCodeCMRByAgentByUUID(this.agent, this.uuidQR).subscribe(data => { 
                this.welcomeQr(data);
            });
        }else{
            this.qRCodeController.getQRCodeCMRByUUID(this.uuidQR).subscribe(data => { 
                this.welcomeQr(data);
            });
        }
    }
  }
  
  welcomeQr(data: RouteCMRQrDto){
        if(data == null){
            this.filedto = null;
        }else
            this.filedto = data.qr;
        if(this.filedto != null && this.filedto.fileBytes != null)
            this.formatDocumentQRCode = 'data:image/' + this.filedto.fileType + ';base64,' + this.filedto.fileBytes;
  }
}
